<div class="fixed inset-0 overflow-y-auto bg-pattern">
  <div class="flex min-h-full items-center justify-center px-4 py-8">
    <div class="w-full max-w-md bg-white/70 backdrop-blur-xl shadow-2xl rounded-2xl">
      <div class="p-6 pb-0 flex flex-col items-center justify-center">
        <div class="fill-current text-center">
          <img class="w-52" src="assets/images/login-register/logo_clarity_color2.svg" alt="Logo Clarity" />
        </div>
      </div>

      <div class="text-center mt-4">
        <h2 class="title m-0">Bienvenido</h2>
        <h4 class="body-2 text-secondary m-0">
          Ingresa tus credenciales de acceso
        </h4>
      </div>

      <div [formGroup]="form" class="p-6 flex flex-col gap-4">

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Correo</mat-label>
          <input formControlName="email" matInput required [errorStateMatcher]="matcher" />
          <mat-error *ngIf="form.controls['email'].hasError('required')">
            Necesitamos una dirección de correo electrónico para iniciar sesión.
          </mat-error>
          <mat-error *ngIf="form.controls['email'].hasError('invalidEmail') && !form.controls['email'].hasError('required')">
            La dirección de correo electrónico no es válida.
          </mat-error>
          <mat-error *ngIf="form.controls['email'].hasError('sqlInjection')">
            No se permiten palabras clave SQL.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Contraseña</mat-label>
          <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
            (keypress)="handleKeyPress($event)" autocomplete="off"
            data-lpignore="true" data-form-type="password" matInput required [errorStateMatcher]="matcher" />
          <button (click)="togglePasswordVisibility('password')" mat-icon-button matIconSuffix
            matTooltip="Mostrar u ocultar contraseña" type="button">
            <img *ngIf="showPassword" src="assets/icons/home/visibility.svg" width="22" height="20" alt="Mostrar" />
            <img *ngIf="!showPassword" src="assets/icons/home/visibility_off.svg" width="22" height="20" alt="Ocultar" />
          </button>
          <mat-hint>Presiona el ojo para ver lo que escribes.</mat-hint>
          <mat-error *ngIf="form.controls['password'].hasError('required')">Una contraseña es indispensable para acceder</mat-error>
          <mat-error *ngIf="form.controls['password'].hasError('minlength')">
            La contraseña debe tener al menos 5 caracteres
          </mat-error>
        </mat-form-field>

        <div class="flex justify-center my-1 overflow-x-auto">
          <re-captcha *ngIf="(isRecaptchaVisible && recaptchaSiteKey?.site_key) || !isButtonVisible"
            formControlName="recaptcha" [siteKey]="recaptchaSiteKey?.site_key || ''"
            (resolved)="onRecaptchaResolved($event)" [size]="recaptchaSize">
          </re-captcha>

          <div *ngIf="!recaptchaSiteKey?.site_key || recaptchaSiteKey?.site_key == ''" role="status" class="mt-4">
            <svg aria-hidden="true" class="inline w-8 h-8 text-slate-400 animate-spin fill-Navy" viewBox="0 0 100 101"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
          </div>
        </div>

        <button *ngIf="isButtonVisible" [disabled]="!form.valid" (click)="onSubmit($event)" mat-raised-button
          type="button" class="auth-btn-primary w-full">
          Ingresar
        </button>

        <div *ngIf="!isButtonVisible || !isRecaptchaVisible" class="flex items-center justify-center my-2">
          <svg aria-hidden="true" class="inline w-8 h-8 text-slate-400 animate-spin fill-Navy" viewBox="0 0 100 101"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
          </svg>
        </div>

        <button mat-raised-button [routerLink]="['/restablecer-contrasena']" type="button" class="w-full">
          ¿Olvidó su contraseña?
        </button>

        <p class="text-sm text-center">
          ¿No tienes una cuenta?<br />
          <a [routerLink]="['/registrarse']" class="text-Teal hover:underline transition-colors duration-200">Créala aquí</a>
        </p>
      </div>
    </div>
  </div>
</div>
